/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_error_page_invalid_request_desc_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page requires valid challenge and redirect_port parameters.`)
};

const zh_hans1_error_page_invalid_request_desc_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该页面需要有效的 challenge 和 redirect_port 参数。`)
};

const zh_hant1_error_page_invalid_request_desc_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此頁面需要有效的 challenge 與 redirect_port 參數。`)
};

const fr_error_page_invalid_request_desc_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette page nécessite des paramètres challenge et redirect_port valides.`)
};

const de_error_page_invalid_request_desc_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Seite benötigt gültige Parameter challenge und redirect_port.`)
};

const ja_error_page_invalid_request_desc_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このページには有効な challenge と redirect_port パラメータが必要です。`)
};

const ko_error_page_invalid_request_desc_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 페이지에는 유효한 challenge 및 redirect_port 매개변수가 필요합니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const error_page_invalid_request_desc_line1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.error_page_invalid_request_desc_line1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("error_page_invalid_request_desc_line1", locale)
	if (locale === "en") return en_error_page_invalid_request_desc_line1(inputs)
	if (locale === "zh-Hans") return zh_hans1_error_page_invalid_request_desc_line1(inputs)
	if (locale === "zh-Hant") return zh_hant1_error_page_invalid_request_desc_line1(inputs)
	if (locale === "fr") return fr_error_page_invalid_request_desc_line1(inputs)
	if (locale === "de") return de_error_page_invalid_request_desc_line1(inputs)
	if (locale === "ja") return ja_error_page_invalid_request_desc_line1(inputs)
	return ko_error_page_invalid_request_desc_line1(inputs)
};